import { ReactNode, useMemo } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { createMyTheme } from "@/mui";

interface MuiThemeConfigProviderProps {
  children: ReactNode;
  initialPrimary?: string; // برای SSR
}

export const MuiThemeConfigProvider = ({
  children,
  initialPrimary,
}: MuiThemeConfigProviderProps) => {

  const theme = useMemo(() => {
    return createMyTheme(initialPrimary);
  }, [initialPrimary]);


  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};
